import { render, staticRenderFns } from "./FolderDeleteModal.vue?vue&type=template&id=66804dde&scoped=true&"
import script from "./FolderDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./FolderDeleteModal.vue?vue&type=script&lang=ts&"
import style0 from "./FolderDeleteModal.vue?vue&type=style&index=0&id=66804dde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66804dde",
  null
  
)

export default component.exports